import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes';
import { Router, ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RoutingConfig } from '@app/routing/routing.config';
import { DialogComponentModel } from '@app/core/models/diallog';
import { PrimeNGConfig } from 'primeng/api';

@UntilDestroy()
@Component({
  selector: 'app-sign-need',
  templateUrl: 'sign-need.component.html',
  styleUrls: [`./sign-need.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SignNeedComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;
  public SNContent: string;
  private SNIntent: string | null = null;
  private SNRedirectUrl: string | null = null;

  @Input() Data: any;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    public ref: DynamicDialogRef,
    private router: Router,
    private dialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;

    this.onSignNeedInputConfig();
  }

  onSignNeedInputConfig(): void {
    const InputConfig = this.dialogConfig.data as DialogComponentModel || null;
    const includeData = InputConfig.includeData as any;
    if (includeData && typeof includeData === 'object' && !Array.isArray(includeData)) {
      this.SNContent = includeData.content || '';
      this.SNIntent = includeData.intent || null;
      this.SNRedirectUrl = includeData.redirectUrl || null;
      return;
    }
    this.SNContent = (includeData as string) || '';
  }

  onRouteToSignIn($event: Event): void {
    $event.preventDefault();
    const qp: string[] = [];
    qp.push(`redirectUrl=${encodeURIComponent(this.SNRedirectUrl || location.pathname)}`);
    if (this.SNIntent) {
      qp.push(`intent=${encodeURIComponent(this.SNIntent)}`);
    }
    this.router.navigateByUrl(`/${RoutingConfig.Login}/${RoutingConfig.SignIn}?${qp.join('&')}`).catch();
    this.onCloseDialog();
  }

  onRouteToSignUp($event: Event): void {
    $event.preventDefault();
    const qp: string[] = [];
    qp.push(`redirectUrl=${encodeURIComponent(this.SNRedirectUrl || location.pathname)}`);
    if (this.SNIntent) {
      qp.push(`intent=${encodeURIComponent(this.SNIntent)}`);
    }
    this.router.navigateByUrl(`/${RoutingConfig.Login}/${RoutingConfig.SignUp}?${qp.join('&')}`).catch();
    this.onCloseDialog();
  }

  onCloseDialog(): void {
    this.ref.close()
  }
}
